import React, { memo } from "react";
import useWhichEnsureSection from "../hooks/useWhichEnsureSection";
import ClientTypeField from "./ClientTypeField";
import FieldWhichEnsure from "./FieldWhichEnsure";
import HousingTypeField from "./HousingTypeField";

const SectionFieldsWhichEnsure = () => {
    const { isOwner, isTenant, clientType } = useWhichEnsureSection();
    return (
        <>
            <ClientTypeField isTenant={isTenant} />
            {isOwner && <FieldWhichEnsure />}
            {clientType && <HousingTypeField />}
        </>
    );
};

export default memo(SectionFieldsWhichEnsure);
